import { Button, Icon } from "@sagot/ui";
import type { ActionLabels } from "./labels";
import type { CardFailure } from "./use-confirm-flow";

export interface FailureNoticeProps {
  failure: CardFailure;
  labels: ActionLabels;
  submitting: boolean;
  onRetry: () => void;
}

/** Why the last attempt did not go through (never raw server text) + "Try again" where it can help. */
export function FailureNotice({ failure, labels, submitting, onRetry }: FailureNoticeProps) {
  return (
    <div role="alert" className="flex flex-wrap items-center gap-2 rounded-md bg-danger-soft p-2.5 text-xs">
      <Icon name="alert-circle" className="size-4 text-danger" />
      <span className="min-w-0 flex-1 font-semibold text-fg">{failure.message}</span>
      {failure.retryable ? (
        <Button variant="secondary" size="sm" className="min-h-11" onClick={onRetry} disabled={submitting}>
          <Icon name="refresh-cw" />
          {labels.retry}
        </Button>
      ) : null}
    </div>
  );
}
